import React from 'react';
import { cellCode, getRiskLevel, riskLabel, riskColours, RiskLevel } from '../utils/riskUtils';
import { RiskCoordinates } from './RiskBadge';
import './RiskSummary.css';

interface Props {
  ratings: RiskCoordinates[];
  onCellClick?: (likelihood: number, consequence: number) => void;
}

export default function RiskHeatmap({ ratings, onCellClick }: Props) {
  const counts = new Map<string, number>();
  ratings.forEach(({ likelihood, consequence }) => {
    const code = cellCode(likelihood ?? 0, consequence ?? 0);
    if (code) counts.set(code, (counts.get(code) ?? 0) + 1);
  });
  return <div className="risk-heatmap">
    <table>
      <caption>Likelihood A–E × Consequence 1–5</caption>
      <thead><tr><th scope="col">Likelihood</th>{['Insignificant', 'Minor', 'Moderate', 'Major', 'Catastrophic'].map((label, i) =>
        <th scope="col" key={label}>{i + 1}<br />{label}</th>)}</tr></thead>
      <tbody>{[5, 4, 3, 2, 1].map((l, i) => <tr key={l}>
        <th scope="row">{cellCode(l, 1)[0]} {['Almost certain', 'Likely', 'Possible', 'Unlikely', 'Rare'][i]}</th>
        {[1, 2, 3, 4, 5].map(c => {
          const code = cellCode(l, c);
          const level = getRiskLevel(l, c)!;
          return <td key={c}><button type="button" className={`btn btn-sm risk-colour-${level}`} style={riskColours[level]}
            aria-label={`${code} · ${riskLabel(level)}: ${counts.get(code) ?? 0}`}
            onClick={() => onCellClick?.(l, c)} disabled={!onCellClick}>
            <span>{code}</span><strong>{counts.get(code) ?? 0}</strong>
          </button></td>;
        })}
      </tr>)}</tbody>
    </table>
    <div className="risk-summary-legend">{(['low', 'moderate', 'high', 'very_high'] as RiskLevel[]).map(level =>
      <span key={level} className={`risk-summary-badge risk-colour-${level}`} style={riskColours[level]}>{riskLabel(level)}</span>)}</div>
  </div>;
}
